var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.483 118.099h57.754s-6.918-10.906-11.861-11.45c-2.296-.255-3.734.902-5.068 2.106-2.171 1.96-5.619 1.239-6.802-1.429a63.84 63.84 0 0 0-2.95-5.831M100.819 112.186c-2.3-.375-4.61-.569-5.657-.108-2.47 1.092-7.049 6.017-7.049 6.017h55.701",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.291 99.41c-3.309-5.174-7.936-10.241-13.563-10.755-11.861-1.092-14.331 13.087-17.294 14.722-2.963 1.636-7.412-9.27-13.836-3.815-6.424 5.451-5.931 8.179-9.388 7.087-3.456-1.092-5.713-2.78-9.664.492a26.506 26.506 0 0 0-3.596 3.591c-1.343 1.636-3.348 2.417-5.311 1.998M59.972 172.632c-1.71-2.192-3.86-4.018-6.359-4.247-6.671-.613-8.057 7.359-9.725 8.278-1.668.92-4.168-5.213-7.78-2.145-3.613 3.069-3.336 4.601-5.281 3.988-1.945-.613-3.215-1.562-5.437.276a15.015 15.015 0 0 0-2.023 2.02c-.758.92-1.884 1.36-2.99 1.123-1.658-.359-3.924-.734-4.764-.363-1.39.613-3.964 3.384-3.964 3.384h65.31s-3.89-6.133-6.672-6.44c-2.781-.306-3.336 3.069-5.835 2.452 0 0-1.2-3.444-3.344-6.729M35.007 29.405h46.686s-3.89-6.133-6.67-6.44c-2.782-.306-3.337 3.07-5.836 2.452 0 0-3.448-9.897-9.093-12.145",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.472 12.91c-5.081.867-6.355 7.388-7.854 8.217-1.668.92-4.167-5.214-7.78-2.145-3.613 3.069-3.336 4.6-5.28 3.988-1.946-.613-3.215-1.563-5.438.276-.87.72-1.533 1.424-2.023 2.02-.758.92-1.884 1.36-2.989 1.122-1.659-.358-3.924-.734-4.765-.362-1.39.613-3.964 3.383-3.964 3.383h16.107",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.521 187.699s11.445 5.948 24.38.497c12.935-5.451 12.442-17.601 12.442-17.601l-36.822 17.104Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M144.521 187.699s11.445 5.948 24.38.497c12.935-5.451 12.442-17.601 12.442-17.601l-36.822 17.104Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.912 128.462-56.476 21.317 29.111 44.865 57.222-29.746-29.857-36.436Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.369 185.913-.611-1.658c18.151-6.642 26.447-25.952 26.53-26.146l1.633.682c-.347.82-8.686 20.216-27.552 27.122Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.719 158.454c0 1.23-1.17 2.231-2.613 2.231-1.442 0-2.612-.997-2.612-2.231s1.17-2.231 2.612-2.231c1.443 0 2.613.997 2.613 2.231Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.585 184.009c-9.92 2.568-14.898 12.055-19.468 11.239-4.921-.88-5.108-1.99-7.01-2.443-1.897-.453-.229.048-.614.056-.386.009-.395-.082-.013.078.38.16-1.486-.091.49.337 1.979.423 2.035 1.592 7.212 2.434 4.834.785 9.626-8.567 19.507-11.209.251-.147.19-.306-.108-.492h.004Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.918 184.743c-16.708 4.294-9.067 15.386-28.487 8.688-.364-.125-.238.052-.33.125-.094.069-.055-.017-.02.082.034.099-.13.156.177.259 19.39 6.612 12.389-4.005 28.782-8.666a12.432 12.432 0 0 0-.117-.492l-.005.004Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.079 185.403c-14.85 3.967-11.454 14.239-28.955 8.533-.455-.147-.226.06-.338.125-.113.065-.074-.026-.022.082s-.195.134.195.263c19.914 6.466 12.688-4.514 29.076-8.929-.03-.164.087.095.035-.069l.009-.005Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.139 185.645c-14.386 4.29-11.575 14.601-29.297 9.603-.58-.164-.204.056-.35.117-.148.06-.096-.044-.018.069.078.112-.29.112.216.254 20.131 5.762 13.434-5.205 29.402-9.987-.026-.16.104.104.047-.06v.004Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.295 186.525a6.82 6.82 0 0 0-.125-.492c-16.579 5.167-7.655 12.305-30.043 12.331-.38 0-.199.151-.281.22-.078.069-.03.031-.022.039.156.151-.117.255.29.251 22.479-.026 13.928-7.579 30.181-12.353v.004Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.131 185.986c.013-.155-.035-.315-.1-.479-16.942 5.209-7.689 12.637-29.163 11.027-1.642-.121.373.143-.498.22-.04 0-.312-.073.112.035.425.108-1.303.129.408.259 21.434 1.618 12.619-6.025 29.241-11.062Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.615 186.366c-10.111 5.779-14.482 13.647-25.983 12.982-11.502-.664.65.19-2.625.087-2.392-.078-.659-.026-.646-.022 6.247.514-9.366-.285 3.028.436 12.394.716 15.946-7.294 26.412-12.991.763-.531.642-1.368-.181-.492h-.005Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.823 184.341c-15.521 3.704-9.929 15.435-26.49 9.189-.403-.151-.238.043-.342.108-.109.065-.065-.013-.022.091.04.103-.147.138.182.254 16.882 6.19 11.419-5.213 26.794-9.154a14.37 14.37 0 0 0-.117-.492l-.005.004Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.054 182.719 1.018 3.017-2.703 1.048-1.031-3.008 2.716-1.057Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.849 105.315c9.344 2.607 17.951-2.788 21.296.052 3.604 3.056 3.227 4.053 4.561 5.326 1.339 1.273.213.069.533.246.321.177.286.255.048-.056-.234-.311 1.174.781-.243-.509-1.416-1.287-.901-2.266-4.735-5.417-3.578-2.939-11.969 2.439-21.313-.095-.273 0-.303.16-.147.453Z",
    fill: "#fff",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.927 104.556c15.716 4.419 14.772-8.279 27.456 6.417.238.277.221.07.329.057.113-.013.039.038.057-.057.021-.099.182-.064-.018-.297-12.697-14.614-12.051-2.607-27.686-6.578-.047.151-.095.302-.138.458Z",
    fill: "#fff",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.113 103.938c15.612 4.234 14.789-7.76 27.759 6.768.304.337.213.056.338.056.126 0 .048.056.057-.056.008-.112.225-.017-.035-.307-13.195-14.739-12.468-2.753-27.985-6.922a3.854 3.854 0 0 0-.134.461Z",
    fill: "#fff",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.178 103.714c15.482 3.72 14.971-7.972 28.556 6.055.399.41.195.052.343.069.147.022.056.082.047-.047-.008-.13.29.047-.052-.311-13.706-14.269-13.407-2.542-28.756-6.211-.056.143-.104.29-.138.449v-.004Z",
    fill: "#fff",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.542 102.497a5.566 5.566 0 0 0-.135.462c16.033 3.647 12.078-6.008 30.402 4.596.312.181.234-.026.334-.047.099-.018.039-.009.034-.022-.056-.198.217-.151-.116-.345-18.399-10.652-14.946-.837-30.524-4.649l.005.005Z",
    fill: "#fff",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.416 103.015a1.086 1.086 0 0 0-.147.44c16.349 3.781 12.263-6.263 29.054 5.248 1.283.881-.238-.293.512.056.034.018.22.208-.074-.082-.295-.289 1.131.514-.212-.405-16.757-11.498-13.135-1.485-29.137-5.257h.004Z",
    fill: "#fff",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.023 102.95c11.033.073 18.302-3.863 27.391 2.136 9.088 6.004-.438-.466 2.188 1.174 1.919 1.196.528.333.519.328-4.864-3.388 7.525 4.679-2.27-1.791-9.794-6.47-16.457-2.028-27.746-2.339-.78-.328-.914-.237-.087.492h.005Z",
    fill: "#fff",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.814 104.931c14.465 4.342 15.504-7.907 26.061 5.063.256.315.213.077.334.073.117 0 .048.039.065-.065.017-.103.186-.043-.026-.297-10.847-13.078-11.831-1.157-26.291-5.236-.048.147-.095.298-.139.458l-.004.004ZM75.706 135.074c.33 2.616 1.096 4.178 1.53 5.054.069.147.13.263.168.358l1.807-.738c-.052-.125-.13-.284-.22-.474-3.016-6.138-.646-14.049.242-17.027 2.712-9.055 8.031-13.44 12.017-15.529 4.475-2.344 9.82-3.121 14.304-2.076l.442-1.891c-4.926-1.143-10.778-.302-15.656 2.249-4.315 2.262-10.072 6.988-12.979 16.69-1.84 6.155-2.027 10.441-1.655 13.384Z",
    fill: "#fff",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.244 102.395-.595 2.071a.828.828 0 0 0 .571 1.025l.237.067a.83.83 0 0 0 1.028-.568l.595-2.071a.828.828 0 0 0-.571-1.025l-.237-.067a.83.83 0 0 0-1.028.568Z",
    fill: "#fff",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.259 102.307s-1.975.76-2.997 1.769M102.279 102.294s-1.729.699-2.708 1.968M99.42 102.41s-1.854.376-2.703 2.232M95.894 102.868s-2.032 1.17-2.496 2.81M92.185 104.115s-1.715 1.235-1.95 3.104M88.971 105.82s-.71 1.299-.715 2.676M86.294 107.741s-.394.867-.36 2.732M83.716 110.033s-.204 1.333.07 3.008M81.438 112.998s-.16 1.364.368 2.96M79.592 116.274s.113 1.394.884 2.606",
    stroke: "#222",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.495 113.654-38.746 35.788 45.607 3.298 43.836-25.944-50.697-13.142Z",
    fill: "#0C9C91",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "m74.238 131.574 25.572.047-12.767 7.691-12.805-7.738Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.248 144.405 2.045 13.328 49.272-8.053-2.512-13.937a4.127 4.127 0 0 0-3.306-3.315c-4.349-.811-13.39-1.899-24.813.048-10.817 1.843-16.557 5.568-19.178 7.842a4.505 4.505 0 0 0-1.512 4.087h.004Z",
    fill: "#0C9C91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M84.751 132.428a61.197 61.197 0 0 0-5.761-.776l3.158 19.4 8.417-1.377-2.513-13.936a4.126 4.126 0 0 0-3.305-3.315l.004.004Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.248 144.405 2.045 13.328 49.272-8.053-2.512-13.937a4.127 4.127 0 0 0-3.306-3.315c-4.349-.811-13.39-1.899-24.813.048-10.817 1.843-16.557 5.568-19.178 7.842a4.505 4.505 0 0 0-1.512 4.087h.004Z",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.536 157.521c13.596-2.199 24.336-5.707 23.99-7.837-.348-2.129-11.65-2.073-25.246.126-13.596 2.199-24.336 5.707-23.99 7.837.348 2.129 11.65 2.073 25.246-.126Z",
    fill: "#0C9C91",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.69 150.016c.308 1.891-10.08 5.141-23.198 7.26-13.117 2.119-24.004 2.309-24.311.423-.308-1.891 10.08-5.141 23.198-7.26 13.121-2.123 24.003-2.309 24.311-.423Z",
    fill: "#0C9C91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.69 150.016c.308 1.891-10.08 5.141-23.198 7.26-13.117 2.119-24.004 2.309-24.311.423-.308-1.891 10.08-5.141 23.198-7.26 13.121-2.123 24.003-2.309 24.311-.423Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.69 150.016c.308 1.891-10.08 5.141-23.198 7.26-13.117 2.119-24.004 2.309-24.311.423-.308-1.891 10.08-5.141 23.198-7.26 13.121-2.123 24.003-2.309 24.311-.423Z",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.268 18.46c-1.035-.687-2.356-1.334-3.886-2.076-4.037-1.969-9.062-4.42-11.874-9.28l-.333.19c2.872 4.964 7.953 7.44 12.038 9.435 1.517.738 2.825 1.377 3.843 2.05 3.704 2.46 5.389 4.925 5.406 4.95l.317-.211c-.07-.104-1.742-2.55-5.511-5.054v-.004Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.169 22.448c.03.185.048.358.056.522l.386-.017a5.28 5.28 0 0 0-.061-.553h.009s-.013-.039-.017-.056c-.395-2.365-2.548-6.362-7.612-10.777-5.636-4.912-4.856-8.222-4.847-8.257l-.373-.099c-.017.07-.225.915.243 2.357a18.71 18.71 0 0 1-.663-1.584l-.364.125c.017.047 1.755 4.972 5.437 8.584a93.325 93.325 0 0 0 1.681 1.602c-4.805-3.829-6.646-8.542-6.663-8.59l-.36.135c.013.038 1.075 2.753 3.665 5.753-3.526-3.604-4.592-7.842-4.6-7.89l-.373.09c.009.031.403 1.615 1.503 3.674-1.065-1.571-1.802-2.823-1.819-2.849l-.329.194c.034.056 3.318 5.607 6.095 8.132.208.19.416.388.619.591a59.878 59.878 0 0 1-1.572-.971c-4.081-4.049-5.623-8.226-5.641-8.274l-.359.13c.017.043 1.261 3.422 4.466 7.065-3.496-2.84-5.055-7.147-5.073-7.195l-.363.125c.017.052 1.888 5.223 6.129 8.063.195.13.399.254.598.384.286.28.585.565.893.841a64.108 64.108 0 0 1-2.526-1.765c-2.214-2.253-3.721-4.467-3.747-4.51l-.316.211c.082.121.862 1.27 2.096 2.728-.16-.142-.312-.28-.45-.419-2.56-2.494-2.547-4.363-2.547-4.385h-.191l-.191-.013c0 .052-.013.833.628 2.046-1.13-1.57-1.65-2.594-1.659-2.607l-.342.173c.013.026 1.443 2.84 4.757 6.379.086.095.182.173.268.263-3.249-2.831-4.423-5.33-4.436-5.36l-.351.16c.013.025.88 1.877 3.171 4.208-3.448-2.801-3.53-4.571-3.53-4.588h-.386c0 .082.048 2.058 4.012 5.157 1.07.838 2.07 1.52 3.019 2.11.243.178.49.355.75.532-.503-.22-.954-.406-1.339-.557-4.531-1.757-6.533-6.543-6.554-6.595l-.356.143c.018.038 1.2 2.87 3.808 5.036a53.396 53.396 0 0 1-1.256-.867 8.244 8.244 0 0 1-.771-.803c-2.686-3.211-3.258-3.966-3.267-3.975l-.307.229c.022.026.502.66 2.699 3.297-1.252-1.01-2.353-2.059-3.119-3.103l-.308.224c.273.372.594.743.936 1.114l-.26.229c.039.047 4.133 4.579 8.538 6.741 3.098 1.524 6.342 3.263 8.729 5.223.26.28.408.457.412.461l.065-.056c.437.384.845.777 1.204 1.179.741.992 1.252 1.739 1.265 1.76l.199-.12.143-.043a9.019 9.019 0 0 0-.364-.959c.234.436.36.695.364.708l.234-.095.057-.008.065.272.372-.082c-.061-.285-.13-.557-.195-.82l.13-.044c-.013-.034-.139-.392-.42-.97a15.43 15.43 0 0 0-.706-1.852c.537.807.974 1.717 1.286 2.762l-.004-.004Zm-7.568-5.469a38.638 38.638 0 0 0-1.256-.746c.914.422 1.689.798 2.196 1.13.724.475 1.612 1.394 2.456 2.387-.723-.734-1.91-1.83-3.396-2.767v-.004Zm.477-.712c.818.466 1.572.945 2.248 1.493.117.16.225.311.325.454a21.703 21.703 0 0 0-2.578-1.951l.005.004Zm-.178-2.123.126.13c-.009 0-.013-.01-.022-.014-.035-.039-.069-.078-.108-.116h.004Zm1.122 1.19c.13.148.256.299.381.445l-.177-.086a37.13 37.13 0 0 0-.39-.475c.06.04.125.078.186.117Zm-.927.26s.017.013.026.017c.061.052.121.108.182.16a10.462 10.462 0 0 1-.741-.41c.178.077.36.155.533.233Zm-2.305-1.45c-.095-.078-.195-.152-.29-.23.165.113.329.221.494.329-.069-.03-.134-.065-.204-.1Zm1.889-2.292c2.902 2.529 4.826 4.907 6.009 6.905-.252-.293-.598-.746-.941-1.187-1.13-1.463-2.837-3.672-4.613-5.24-1.317-1.16-2.179-2.045-2.812-2.826.629.734 1.404 1.52 2.357 2.352v-.004Zm-.043.565c-.065-.065-.13-.13-.191-.194.143.13.286.259.438.393.463.41.927.867 1.373 1.346l-.017-.017c-.503-.475-1.04-.975-1.599-1.528h-.004Zm-.568 1.73.689.415c.225.255.451.51.663.764-.035-.017-.07-.03-.104-.047a32.95 32.95 0 0 0-1.122-.941c-.169-.134-.329-.272-.49-.406l.364.22v-.004Zm-6.156-3.68A27.95 27.95 0 0 0 182 12.157c.356.363.724.725 1.114 1.08-.875-.536-1.72-1.166-2.469-1.965a52.032 52.032 0 0 1-.733-.807Zm3.509 3.793s.009.004.013.009c0 0-.008 0-.013-.005v-.004Zm-2.66-.725c.208.1.425.194.646.28 1.217.475 3.145 1.317 5.103 2.538a69.106 69.106 0 0 0-1.828-.85 74.627 74.627 0 0 1-3.123-1.485c-.26-.155-.529-.319-.793-.483h-.005Zm-6.684-4.36c.862.79 1.841 1.563 2.872 2.301 1.209 1.1 2.816 2.055 4.423 2.875 1.083.651 2.11 1.238 2.989 1.743.841.484 1.564.898 2.041 1.2.424.268.823.553 1.195.833-1.906-1.212-4.033-2.322-6.095-3.336-3.049-1.498-5.952-4.156-7.42-5.62l-.005.005Zm15.344 9.336c1.105.989 2.088 2.12 2.803 3.401-.052-.06-.1-.12-.152-.177-.736-.988-1.702-2.218-2.651-3.22v-.004Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.479 56.354c-2.603 0-4.224-.552-5.133-.867-.152-.052-.273-.095-.373-.121l.503-1.843c.13.034.294.09.494.16 6.381 2.18 13.836-1.092 16.639-2.322 8.534-3.742 12.177-9.453 13.728-13.579 1.746-4.635 1.85-9.926.281-14.156l1.798-.66c1.724 4.648 1.616 10.436-.286 15.49-1.685 4.471-5.61 10.643-14.75 14.657-5.796 2.546-9.972 3.246-12.901 3.246v-.005Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.184 22.768 1.933-.822a.832.832 0 0 1 1.091.436l.087.203a.828.828 0 0 1-.438 1.087l-1.933.822a.833.833 0 0 1-1.091-.436l-.087-.203a.828.828 0 0 1 .438-1.087Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.371 29.742-52.387 14.41 23.263 46.16 50.433-11.687-21.309-48.883Z",
    fill: "#0C9C91",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "m162.953 54.921 14.638 24.17-26.768 6.457 12.13-30.627Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.31 46.622c-10.462-5.158-22.28-2.62-26.395 5.67l-4.575 7.485 3.462 1.709c1.187 5.952 5.753 11.787 12.597 15.158 6.845 3.375 14.265 3.453 19.737.785l2.083 1.028 3.375-5.52a13.45 13.45 0 0 0 1.2-1.964c4.12-8.291-1.022-19.194-11.484-24.351Z",
    fill: "#0C9C91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "m163.048 55.03-18.121 23.832c4.778.937 9.453.397 13.204-1.433l2.084 1.028 3.375-5.52c.45-.614.853-1.27 1.2-1.964 2.473-4.977 1.602-10.894-1.746-15.944h.004Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.31 46.622c-10.462-5.158-22.28-2.62-26.395 5.67l-4.575 7.485 3.462 1.709c1.187 5.952 5.753 11.787 12.597 15.158 6.845 3.375 14.265 3.453 19.737.785l2.083 1.028 3.375-5.52a13.45 13.45 0 0 0 1.2-1.964c4.12-8.291-1.022-19.194-11.484-24.351Z",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.214 78.448c4.118-8.292-1.022-19.194-11.482-24.351-10.46-5.157-22.278-2.617-26.397 5.674-4.118 8.292 1.023 19.194 11.483 24.351 10.459 5.157 22.278 2.617 26.396-5.674Z",
    fill: "#0C9C91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M160.214 78.448c4.118-8.292-1.022-19.194-11.482-24.351-10.46-5.157-22.278-2.617-26.397 5.674-4.118 8.292 1.023 19.194 11.483 24.351 10.459 5.157 22.278 2.617 26.396-5.674Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.214 78.448c4.118-8.292-1.022-19.194-11.482-24.351-10.46-5.157-22.278-2.617-26.397 5.674-4.118 8.292 1.023 19.194 11.483 24.351 10.459 5.157 22.278 2.617 26.396-5.674Z",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.037 77.868c3.862-7.775-.96-17.998-10.771-22.835-9.81-4.837-20.893-2.456-24.754 5.318-3.862 7.775.96 17.998 10.77 22.835 9.81 4.837 20.894 2.456 24.755-5.319Z",
    fill: "#0C9C91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M159.037 77.868c3.862-7.775-.96-17.998-10.771-22.835-9.81-4.837-20.893-2.456-24.754 5.318-3.862 7.775.96 17.998 10.77 22.835 9.81 4.837 20.894 2.456 24.755-5.319Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.272 55.042c-7.885-3.889-16.592-3.107-21.712 1.386-.997 7.125 3.825 15.123 12.233 19.266 7.616 3.755 15.972 3.263 21.253-.664 1.642-7.269-3.128-15.724-11.774-19.988Z",
    fill: "#0C9C91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148.272 55.042c-7.885-3.889-16.592-3.107-21.712 1.386-.997 7.125 3.825 15.123 12.233 19.266 7.616 3.755 15.972 3.263 21.253-.664 1.642-7.269-3.128-15.724-11.774-19.988Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.037 77.868c3.862-7.775-.96-17.998-10.771-22.835-9.81-4.837-20.893-2.456-24.754 5.318-3.862 7.775.96 17.998 10.77 22.835 9.81 4.837 20.894 2.456 24.755-5.319Z",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.838 68.254 8.23 15.4s7.898 4.855 30.75-9.544c22.85-14.398 22.01-19.918 22.01-19.918l-10.08-19.086-50.91 33.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m34.838 68.254 8.23 15.4s7.898 4.855 30.75-9.544c22.85-14.398 22.01-19.918 22.01-19.918l-10.08-19.086-50.91 33.148Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.275 29.172c-4.111 3.863-41.487 34.014-50.507 41.283-.663.535-.294 1.6.56 1.618l48.82.85c.81.013 1.59-.297 2.167-.863l55.506-55.08c.515-.51.034-1.378-.676-1.21L54.306 28.629c-.385.09-.74.276-1.03.548v-.004Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.077 99.1a.882.882 0 0 1-.884-.876c-.065-9.292-.143-24.99.026-25.663.104-.423.173-.7 15.816-13.604 7.62-6.289 15.322-12.577 15.4-12.642a.89.89 0 0 1 1.248.125.881.881 0 0 1-.121 1.243C43.073 57.066 25.836 71.262 23.943 73.14c-.09 2.046-.035 15.862.026 25.08 0 .488-.39.885-.88.89h-.004l-.008-.009Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.88 97.814h-5.597v6.996h5.597v-6.996ZM20.482 104.892c-.221 3.298-1.698 25.102-2.92 32.634-1.312 8.109-1.893 10.665-1.897 10.686a.356.356 0 0 0 .342.436.36.36 0 0 0 .347-.276c.004-.026.589-2.594 1.906-10.734 1.23-7.596 2.72-29.608 2.928-32.746h-.71.004Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.526 104.892c-.252 4.329-2.084 34.921-4.622 45.034a.354.354 0 0 0 .255.431.351.351 0 0 0 .429-.254c2.56-10.204 4.406-41.011 4.644-45.206h-.71l.004-.005Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.483 104.892c-.277 3.682-2.859 37.187-4.817 45.422a.356.356 0 0 0 .347.436.35.35 0 0 0 .342-.272c1.98-8.326 4.583-42.172 4.839-45.586h-.71Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.83 104.892c-.204 4.195-1.941 39.138-3.267 45.72a.354.354 0 0 0 .277.418.33.33 0 0 0 .07.009.355.355 0 0 0 .346-.285c1.36-6.733 3.076-41.593 3.284-45.862h-.71ZM24.723 104.892h-.71c-.122 4.329-.954 35.323.016 46.203a.353.353 0 0 0 .351.324h.03a.354.354 0 0 0 .321-.384c-.966-10.859-.134-41.896-.013-46.143h.005Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.952 104.892h-.71c-.196 4.415-1.92 43.199-1.829 45.711.009.19.165.341.355.341h.013a.36.36 0 0 0 .343-.367c-.087-2.46 1.65-41.697 1.828-45.685ZM24.545 104.892c.061 4.826.555 44.969.555 45.28a.356.356 0 0 0 .71 0c0-.268-.49-40.144-.554-45.28h-.71ZM20.941 104.892c-.23 4.239-1.932 34.606-4.237 42.349a.359.359 0 0 0 .239.445c.034.008.069.012.1.012a.35.35 0 0 0 .337-.254c2.365-7.946 4.042-38.288 4.267-42.552h-.71.004ZM56.75 44.774c.459.76-.499 2.18-2.145 3.173-1.646.992-3.353 1.174-3.816.414-.46-.76.498-2.18 2.144-3.172 1.646-.993 3.353-1.174 3.817-.415Z",
    fill: "#92E3A9",
    stroke: "#222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h206v200H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.4401ab9503ed3621623d457b9bc64d74.svg";
export { ForwardRef as ReactComponent };